import React from 'react'
import "./css/project.css"

const Projects = () => {
  return (
    <>
      <h1
        style={{
          color: "rgb(40,116,240)",
          textDecoration: "underline",
          textAlign: "center",
        }}
      >
        Projects
      </h1>
      <div className="Projectmain" id="projects">
        <div className="projectchild ">
          <img className="projectimage" src="ecom.png" alt="" />
          <h2 className="projectheading">Full Stack E-commerce</h2>
          <div className="exceptions">
            <p>An Ecommerce Webapp for buying and selling electronics.</p>
            <p>An individual project.</p>
            <div className="projecttechstack1 projecttech">
              <img src="/html.png" alt="" />
              <img src="/css.png" alt="" />
              <img src="/js.png" alt="" />
              <img src="/react.jpg" alt="" />
            </div>
            <div className="projecttechstack1 projecttech">
              <img src="mui.png" alt=''/>
              <img src="nodeg.png" alt="" />
              <img src="mongo.png" alt="" />
              <img src="expressg.png" alt="" />
            </div>
          </div>
          <div className="projectbuttons">
            <a
              className="underline"
              href="https://github.com/rozodkarbharat/full-stack-ecommerce"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectbutton">
                Code<img src="./images/github.png" alt=""></img>
              </button>
            </a>

            <a
              className="underline"
              href="https://ecom-electronics.netlify.app"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectbutton">
                Live<img src="./images/website.png" alt=""></img>
              </button>
            </a>
          </div>
        </div>
        <div className="projectchild">
          <img className="projectimage" src="kfc.png" alt="" />
          <h2 className="projectheading">KFC Clone</h2>
          <div className="exceptions">
            <p>
              E-commerce app for food delivery. Here we can add food to cart and
              order it. for login We have used Login with OTP as well as normal
              signup.
            </p>
            <p>An individual project</p>
            <div className="projecttechstack4 projecttech">
              <img src="/html.png" alt="" />
              <img src="/css.png" alt="" />
              <img src="/js.png" alt="" />
              <img src="/react.jpg" alt="" />
            </div>
            <div className="projecttechstack4 projecttech">
              <img src="firebaseg.png" alt="" />
              <img src="mui.png" alt="" />
            </div>
          </div>

          <div className="projectbuttons">
            <a
              className="underline"
              href="https://github.com/rozodkarbharat/KFC-clone"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectbutton">
                Code<img src="./images/github.png" alt=""></img>
              </button>
            </a>

            <a
              className="underline"
              href="https://62e3fd1323b3d709679a3d6c--kfc-rozodkarbharat.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectbutton">
                Live<img src="./images/website.png" alt=""></img>
              </button>
            </a>
          </div>
        </div>
        <div className="projectchild">
          <img className="projectimage" src="harvest.png" alt="" />
          <h2 className="projectheading"> Harvest Clone</h2>
          <div className="exceptions">
            <p>
              Harvest is a time-tracking app for freelancers that includes
              invoicing, expensing, and team management features.
            </p>
            <p>
              A collaborative project built by a team of 4 executed in 4 days.
            </p>
            <div className="projecttechstack3 projecttech">
              <img src="/html.png" alt="" />
              <img src="/css.png" alt="" />
              <img src="/js.png" alt="" />
              <img src="/react.jpg" alt="" />
            </div>
            <div className="projecttechstack3 projecttech">
              <img src="chakrag.png" alt="" />
              <img src="nodeg.png" alt="" />
              <img src="mongo.png" alt="" />
              <img src="expressg.png" alt="" />
            </div>
          </div>

          <div className="projectbuttons">
            <a
              className="underline"
              href="https://github.com/rozodkarbharat/Harvest_clone"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectbutton">
                Code<img src="./images/github.png" alt=""></img>
              </button>
            </a>

            <a
              className="underline"
              href="https://harvestappclone.netlify.app"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectbutton">
                Live<img src="./images/website.png" alt=""></img>
              </button>
            </a>
          </div>
        </div>

        <div className="projectchild">
          <img className="projectimage" src="./images/porter.png" alt="" />
          <h2 className="projectheading">Porter Clone</h2>
          <div className="exceptions">
            <p>A web application of house shifting services by roadways.</p>
            <p>
              A collaborative project built by a team of 6 executed in 4 days.
            </p>
            <div className="projecttechstack2 projecttech">
              <img src="/html.png" alt="" />
              <img src="/css.png" alt="" />
              <img src="/js.png" alt="" />
            </div>
          </div>

          <div className="projectbuttons">
            <a
              className="underline"
              href="https://github.com/rozodkarbharat/Porter"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectbutton">
                Code<img src="./images/github.png" alt=""></img>
              </button>
            </a>

            <a
              className="underline"
              href="https://64f3ec54d019ec4ce73742ee--amazing-bublanina-b623da.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              <button className="projectbutton">
                Live<img src="./images/website.png" alt=""></img>
              </button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Projects
